// changed map keys
import React, { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import { Helmet } from "react-helmet";
import { connect, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { Element, Link } from "react-scroll";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import NotfoundShape from "../../assets/images/404-shape.svg";
import { recentActivity, getResourceDetailsAction } from "../resources/actions";
// images
import NotfoundBG from "../../assets/images/bg/404.jpg";
import menuBg from "../../assets/images/bg/menu/home.svg";
import { default as NotfoundAngle } from "../../assets/images/icons/arrow-right.svg";
import bluePurpleBottom from "../../assets/images/resource/bg/blue/bottom.jpg";
import bluePurpleTop from "../../assets/images/resource/bg/blue/top.jpg";
import greenYellowBottom from "../../assets/images/resource/bg/green/bottom.jpg";
import greenYellowTop from "../../assets/images/resource/bg/green/top.jpg";
import blueLightBlueBottom from "../../assets/images/resource/bg/light-blue/bottom.jpg";
import blueLightBlueTop from "../../assets/images/resource/bg/light-blue/top.jpg";
import pinkYellowBottom from "../../assets/images/resource/bg/pink/bottom.jpg";
import darkBluePurple from "../../assets/images/resource/bg/dark_blue/dark_blue.jpg";
// template design
import pinkYellowTop from "../../assets/images/resource/bg/pink/top.jpg";
import purpleGreenBottom from "../../assets/images/resource/bg/purple/bottom.jpg";
import purpleGreenTop from "../../assets/images/resource/bg/purple/top.jpg";
import greenTealBottom from "../../assets/images/resource/bg/teal/bottom.jpg";
import greenTealTop from "../../assets/images/resource/bg/teal/top.jpg";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import LoginModal from "../../components/loginModal";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";
import "./style.scss";
import { getAccountInformation } from "../account/actions";
import PremiumModal from "../../components/premiumModal";
import ProModal from "../../components/ProModal";
import superagent from "superagent";
import { base_url } from "../../utils/constants";
import logo from "../../assets/images/logo.png";
import DownloadButton from "./DownloadButton";
import { Button, Container } from "react-bootstrap";
import { convertSpaceToHyphen, isHTML } from "../../utils/commonFunctions";
import FAQQuestionAnswer from "../FaqSection/FaqQuestionAnswer";
import MetaTags from "../../components/metas";
import CustomButton from "../../components/Buttons/CustomButton";

const cookie = new Cookies();

const ResourcesTemplate = (props) => {
  const { id } = useParams();
  const [loading] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalLogin, setIsModalLogin] = useState(false);
  const [premiumUpgradeModal, setPremiumUpgradeModal] = useState(false);
  const [premium, setPremium] = useState(false);
  const [pro, setPro] = useState(false);
  const [proUpgradeModal, setProUpgradeModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const user_info = useSelector((state) => state?.my_account?.user_info);
  const proMemberRef = useRef(null);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleOpenSignupModal = () => {
    if (user_info?.auth_token) {
      toast.error("you are already logged in");
    } else {
      setIsModal(true);
    }
  };

  useEffect(() => {
    props.getResourceDetailsAction(id);
  }, [id]);

  const handleLoginModal = () => {
    setIsModalLogin(true);
  };

  const subscribeToPremium = () => {
    superagent
      .get(`${base_url}subscription/PREMIUM`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        window.location = res.body.url;
      });
  };

  const subscribeToPro = () => {
    superagent
      .get(`${base_url}subscription/PRO`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((err, res) => {
        window.location = res.body.url;
      });
  };

  useEffect(() => {
    if (props?.resources_details?.keyword?.length > 0) {
      const dataKeyword = props?.resources_details?.keyword;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.resources_details?.keyword]);

  const resourceFaqsSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: props.resources_details?.faq?.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <>
        <Helmet>
          <title>{`${props.resources_details?.meta_title ?? "Resource Detail - Clarity Cooperative"}`}</title>
          <meta name="description" content={props?.resources_details?.excerpt} />
          <meta name="keywords" content={keyword} />
          <meta name="title" content={props?.resources_details?.meta_title} />
          <meta property="og:title" content={props?.resources_details?.meta_title} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={props?.resources_details?.url} />
          <meta property="og:image" content={logo} />
          <meta property="og:site_name" content="clarity cooperative" />
          <meta property="og:description" content={props?.resources_details?.excerpt} />
          <meta name="twitter:card" content={props?.resources_details?.excerpt} />
          <meta property="twitter:domain" content="ccdev.brethren.io" />
          <meta property="twitter:url" content={props?.resources_details?.url} />
          <meta name="twitter:title" content={props?.resources_details?.meta_title} />
          <meta name="twitter:description" content={props?.resources_details?.excerpt} />
          <meta name="twitter:image" content={logo} />
        </Helmet>
        <MetaTags faqSchema={resourceFaqsSchema} />
        {loading ? (
          <></>
        ) : (
          <>
            {props.resources_details !== undefined ? (
              <>
                <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />

                <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
                <div
                  className={`resourcesTemplateHeroArea section ${
                    (props.resources_details?.resource_color === "pink/yellow" && "resourcesTemplateHeroAreaPinkYellow") ||
                    (props.resources_details?.resource_color === "blue/purple" && "resourcesTemplateHeroAreaBluePurple") ||
                    (props.resources_details?.resource_color === "purple/green" && "resourcesTemplateHeroAreaPurpleGreen") ||
                    (props.resources_details?.resource_color === "green/yellow" && "resourcesTemplateHeroAreaGreenYellow") ||
                    (props.resources_details?.resource_color === "blue/lightBlue" && "resourcesTemplateHeroAreaBlueLightBlue") ||
                    (props.resources_details?.resource_color === "dark_blue/purple" && "resourcesTemplateHeroAreaDarkBluePurple") ||
                    (props.resources_details?.resource_color === "green/teal" && "resourcesTemplateHeroAreaGreenTeal")
                  }`}
                >
                  <div className="mainContainer">
                    <div className="resourcesTemplateHeroContainer">
                      <div className="resourcesTemplateHeroContent ps-3">
                        <span className="categorypub">
                          {props.resources_details?.categories?.map((item) => (
                            <span key={item}>{item}</span>
                          ))}
                        </span>
                        <h1>{props.resources_details?.name}</h1>
                        {user_info?.auth_token ? (
                          <DownloadButton
                            action={props.resources_details?.action === "hyper"}
                            hyperlink={props.resources_details?.hyperlink}
                            hyperlink_title={props.resources_details?.hyperlink_title}
                            download_title={props.resources_details?.download_title}
                            resourceType={props.resources_details?.display_type}
                            userType={props.user_info?.subscription_type}
                            handleLoginModal={handleLoginModal}
                            downloadURL={props.resources_details?.document}
                            setProUpgradeModal={setProUpgradeModal}
                            setPremiumUpgradeModal={setPremiumUpgradeModal}
                            recentActivity={recentActivity}
                            id={id}
                          />
                        ) : (
                          <Link to="test1" spy smooth duration={500}>
                            <Button>Learn More</Button>
                          </Link>
                        )}
                      </div>
                      <div className="resourcesTemplateHeroImg">
                        <img src={props.resources_details?.hero_image} alt={`${convertSpaceToHyphen(props?.resources_details?.name)}-clarity-cooperative`} />
                      </div>
                    </div>
                  </div>
                </div>
                <Element name="test1">
                  <div
                    className="communityAboutArea"
                    style={{
                      background: `url(${
                        (props.resources_details?.resource_color === "pink/yellow" && pinkYellowTop) ||
                        (props.resources_details?.resource_color === "blue/purple" && bluePurpleTop) ||
                        (props.resources_details?.resource_color === "purple/green" && purpleGreenTop) ||
                        (props.resources_details?.resource_color === "green/yellow" && greenYellowTop) ||
                        (props.resources_details?.resource_color === "blue/lightBlue" && blueLightBlueTop) ||
                        (props.resources_details?.resource_color === "dark_blue/purple" && darkBluePurple) ||
                        (props.resources_details?.resource_color === "green/teal" && greenTealTop)
                      }) no-repeat center center / cover`,
                    }}
                  >
                    <div className="mainContainer">
                      <div className="communityAboutContainer">
                        <div className="communityAboutImg">
                          <img
                            src={props.resources_details?.important_image}
                            alt={`${convertSpaceToHyphen(props?.resources_details?.important_title)}-clarity-cooperative`}
                          />
                        </div>
                        <div className="communityAboutContent">
                          <h2>{props.resources_details?.important_title}</h2>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(props.resources_details?.important_paragraph),
                            }}
                          />
                          <div>
                            <CustomButton variant="white" className="mt-30" onClick={handleOpenSignupModal}>
                              Join The Community
                            </CustomButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Element>
                <div
                  className={`communityFeaturesArea comprehensiveArea ${
                    (props.resources_details?.resource_color === "pink/yellow" && "communityFeaturesAreaPinkYellow") ||
                    (props.resources_details?.resource_color === "blue/purple" && "communityFeaturesAreaBluePurple") ||
                    (props.resources_details?.resource_color === "purple/green" && "communityFeaturesAreaPurpleGreen") ||
                    (props.resources_details?.resource_color === "green/yellow" && "communityFeaturesAreaGreenYellow") ||
                    (props.resources_details?.resource_color === "blue/lightBlue" && "communityFeaturesAreaBlueLightBlue") ||
                    (props.resources_details?.resource_color === "dark_blue/purple" && "communityFeaturesAreaDarkBluePurple") ||
                    (props.resources_details?.resource_color === "green/teal" && "communityFeaturesAreaGreenTeal")
                  }`}
                >
                  <div className="mainContainer">
                    <div className="communityFeaturesContainer">
                      <div className="comprehensiveInfoWrap">
                        <div className="comprehensiveInfo mb-2">
                          <h3>{props.resources_details?.expect_title}</h3>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(props.resources_details?.expect_paragraph),
                            }}
                          />
                        </div>

                        <div className="text-center mt-4">
                          <DownloadButton
                            action={props.resources_details?.action === "hyper"}
                            hyperlink={props.resources_details?.hyperlink}
                            hyperlink_title={props.resources_details?.hyperlink_title}
                            download_title={props.resources_details?.download_title}
                            resourceType={props.resources_details?.display_type}
                            userType={props.user_info?.subscription_type}
                            handleLoginModal={handleLoginModal}
                            downloadURL={props.resources_details?.document}
                            setProUpgradeModal={setProUpgradeModal}
                            setPremiumUpgradeModal={setPremiumUpgradeModal}
                            recentActivity={recentActivity}
                            id={id}
                          />
                        </div>
                      </div>
                      <div className="communityFeaturesWrap">
                        <h4 className="comprehensiveTitle">{props.resources_details?.expect_second_title}</h4>
                        <ul className="communityFeaturesItems">
                          {props.resources_details?.expect?.map((item) => (
                            <li key={item?.question}>
                              <h4>{item.question}</h4>
                              <p>{item.answer}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="section faqSection">
                  <Container>
                    <div className="faqHeading text-center">
                      <h2>{props.resources_details?.faq_title}</h2>
                    </div>

                    {/* <DownloadButton
                      action={props.resources_details?.action === "hyper"}
                      hyperlink={props.resources_details?.hyperlink}
                      hyperlink_title={props.resources_details?.hyperlink_title}
                      download_title={props.resources_details?.download_title}
                      resourceType={props.resources_details?.display_type}
                      userType={props.user_info?.subscription_type}
                      handleLoginModal={handleLoginModal}
                      downloadURL={props.resources_details?.document}
                      setProUpgradeModal={setProUpgradeModal}
                      setPremiumUpgradeModal={setPremiumUpgradeModal}
                      recentActivity={recentActivity}
                      id={id}
                    /> */}

                    {props.resources_details?.faq?.length > 0 && (
                      <ul className="faqsItems">
                        {props.resources_details?.faq?.map((FAQ) => {
                          const answers = isHTML(FAQ?.answer) ? FAQ?.answer : `<p>${FAQ?.answer}</p>`;

                          return <FAQQuestionAnswer key={FAQ?.question} questions={FAQ?.question} answer={answers} />;
                        })}
                      </ul>
                    )}
                  </Container>
                </div>
                <div className="resourcesTemplateFooter pt-0">
                  <div className="mainContainer">
                    <div ref={proMemberRef} className="resourcesTemplateContainer">
                      <div className="resourcesTemplateFooterImg">
                        <img
                          src={props.resources_details?.get_image}
                          alt={`${convertSpaceToHyphen(props?.resources_details?.get_title)}-clarity-cooperative`}
                        />
                      </div>
                      <div className="resourcesTemplateFooterContent">
                        <h2>{props.resources_details?.get_title}</h2>
                        <strong>{props.resources_details?.get_sub_title}</strong>
                        <div
                          className="mb-md-5 mb-4"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(props.resources_details?.get_paragraph),
                          }}
                        />

                        <DownloadButton
                          action={props.resources_details?.action === "hyper"}
                          hyperlink={props.resources_details?.hyperlink}
                          hyperlink_title={props.resources_details?.hyperlink_title}
                          download_title={props.resources_details?.download_title}
                          resourceType={props.resources_details?.display_type}
                          userType={props.user_info?.subscription_type}
                          handleLoginModal={handleLoginModal}
                          downloadURL={props.resources_details?.document}
                          setProUpgradeModal={setProUpgradeModal}
                          setPremiumUpgradeModal={setPremiumUpgradeModal}
                          recentActivity={recentActivity}
                          id={id}
                        />
                        {/* </span> */}
                      </div>
                    </div>
                  </div>
                </div>
                <FooterBottom />
              </>
            ) : (
              <>
                <Helmet>
                  <title>Page Not Found - Clarity Cooperative</title>
                </Helmet>
                <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
                <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
                <div className="notfoundArea">
                  <div
                    style={{
                      background: `url(${NotfoundBG}) no-repeat center center / cover`,
                    }}
                    className="notfoundWrapper"
                  >
                    <img className="notfoundShape" src={NotfoundShape} alt="shape" />
                    <h2>Uh-oh, the waiting room is that way.</h2>
                    <a href="/">
                      Take Me Home <img src={NotfoundAngle} alt="Back" />
                    </a>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </>
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
      <LoginModal isOpen={isModalLogin} onClosed={() => setIsModalLogin(false)} modal={setIsModalLogin} />
      {premiumUpgradeModal && (
        <PremiumModal
          isOpen={premiumUpgradeModal}
          onClosed={() => setPremiumUpgradeModal(false)}
          title="Unlock Premium Features"
          content="Do you like what you’ve experienced so far? Unlock more potential:"
          price="$99"
          Flag="Year"
          submit={subscribeToPremium}
          submitBtn
          values={subscribeToPremium}
          monthly={premium}
          setMonthly={setPremium}
        />
      )}
      {proUpgradeModal && (
        <ProModal
          isOpen={proUpgradeModal}
          onClosed={() => setProUpgradeModal(false)}
          title="Unlock Pro Features"
          content="Do you like what you’ve experienced so far? Unlock more potential:"
          price="$199"
          Flag="Year"
          submit={subscribeToPro}
          submitBtn
          values={subscribeToPro}
          isFreeTrial={false}
          monthly={pro}
          setMonthly={setPro}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  resources_details: state.resources.resources_details,
  user_info: state.my_account.user_info,
});

export default connect(mapStateToProps, {
  getResourceDetailsAction,
  getAccountInformation,
})(withRouter(ResourcesTemplate));
